import { t } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

function Toggle({ options, defaultChecked, renew = true }) {
    const { t } = useTranslation();

    const handleChange = (e) => {
        if (e.target.checked) {
            return options[1].value();
        }
        return options[0].value();
    };
    return (
        <div className="flex justify-start">
            {renew && (
                <div className="">
                    <p
                        className="text-xs font-medium text-slate-300 underline align-middle cursor-pointer mt-1"
                        onClick={() => { window.location.reload() }}
                    >
                        {t("meeting.busy.refresh")}</p>
                </div>
            )}
            <div className="flex items-center justify-end ml-auto">
                <span className={`mr-2 text-sm font-medium transition-colors ${
                    defaultChecked === false 
                        ? renew ? "text-white" : "text-gray-900"
                        : renew ? "text-gray-300" : "text-gray-500"
                }`}>
                    {options[0].label}
                </span>

                <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" defaultChecked={defaultChecked} onChange={(e) => handleChange(e)} className="sr-only peer" />
                    <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-offset-2 peer-focus:ring-indigo-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all after:shadow-sm peer-checked:bg-indigo-600"></div>
                </label>

                <span className={`ml-2 text-sm font-medium transition-colors ${
                    defaultChecked 
                        ? renew ? "text-white" : "text-gray-900"
                        : renew ? "text-gray-300" : "text-gray-500"
                }`}>
                    {options[1].label}
                </span>
            </div>
        </div>
    );
}

export default Toggle;
